export default __webpack_public_path__ + "static/media/num-icon4.bd03ae4d.svg";